export default "__VITE_ASSET__oUk6KuVS__"